const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagementReferral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.02 33.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.41,32.89a.8.8,0,0,0,.82,0c2.82-1.69,19-11.83,19-21.64A10.43,10.43,0,0,0,22.47,4.94a.82.82,0,0,1-1.3,0A10.44,10.44,0,0,0,2.42,11.25C2.42,21.06,18.59,31.2,21.41,32.89Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.61625993251801px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2,24.62c-.56,0-1.08-3.29-1.82-8.32-.48-3.3-1-7-1.41-7s-.75,2.28-1.15,4.48c-.57,3.17-1.21,6.76-2.08,6.76s-1.3-1.52-1.78-3c-.43-1.29-.87-2.63-1.45-2.63-1.23,0-1.58,2.27-1.58,2.3v0H.81v-.08h8c.05-.3.43-2.33,1.66-2.33.64,0,1.07,1.3,1.52,2.68s1,2.93,1.71,2.93,1.47-3.71,2-6.69c.51-2.82.84-4.55,1.23-4.55s.84,2.7,1.49,7.1C19,20,19.67,24.54,20.2,24.54s1.1-2.36,1.62-4.45,1.08-4.35,1.62-4.35,1,.85,1.51,1.75,1.11,1.94,1.72,1.94c1.16,0,1.57-2.22,1.57-2.25v0h6.5v.08H28.32c-.06.3-.49,2.28-1.65,2.28-.66,0-1.23-1-1.79-2s-1-1.71-1.44-1.71-1.05,2.28-1.54,4.29C21.32,22.43,20.78,24.62,20.2,24.62Z",
    className: "appointment-types__type-svg-stroke",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.61625993251801px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementReferral);
export default __webpack_public_path__ + "static/media/management_referral.d5c826665451457f9c844bad08cfbf0e.svg";
export { ForwardRef as ReactComponent };